import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.requirePsychics();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.psychics != this.props.psychics) {
            return true;
        }

        return false;
    }

    render({ psychics, logged_in }) {
        if (psychics && _.size(psychics)) {
            this.props.trackEvent([
                'Psychics',
                logged_in ? 'LI Impression' : 'LO Impression',
                'Keen-API',
            ]);

            return (
                <keen-slider>
                    <row className='is-aligned-center'>
                        <column className='is-7 is-8-mobile'>
                            <h2>Get Psychic Advice Now</h2>
                        </column>
                        <column className='is-5 is-4-mobile'>
                            <p><a href='/daily-psychic-advisors'>Powered by Keen</a></p>
                        </column>
                    </row>
                    <div className='slider-arrows'>
                        <a href='#' onClick={(e) => this.slide(e, 'prev')} data-label='prev' />
                        <a href='#' onClick={(e) => this.slide(e, 'next')} data-label='next' />
                    </div>
                    <div className='slider' ref={el => this.el = el}>
                        {_.map(psychics, this.renderPsychic)}
                    </div>
                </keen-slider>
            );
        }

        return (<keen-slider />);
    }

    renderPsychic = (psychic) => {
        return (
            <a
                href={`https://www.keen.com${psychic.detailsUrl}&tid=V3LTBSLU`}
                target='_blank'
                rel='noopener sponsored'
                onClick={() => this.props.trackEvent([
                    'Psychics',
                    this.props.logged_in ? 'LI Click' : 'LO Click',
                    'Keen-API',
                ])}
            >
                <row>
                    <column className='is-5'>
                        <img
                            src={psychic.pictureURL}
                            alt={psychic.speakerName}
                            height='130'
                            width='130'
                            className='lazyload'
                        />
                        <img
                            src='https://gfx.tarot.com/images/daily-pages/daily-icons/online-now-icon.svg'
                            alt='Online Now'
                            height='40'
                            width='40'
                            className='online-now'
                        />
                    </column>
                    <column className='is-7 has-padding-20-left'>
                        <h4>{psychic.speakerName}</h4>
                        <p>{psychic.listingTitle}</p>
                        <button className='button-black is-pill'>CONNECT TO ADVISOR</button>
                    </column>
                </row>
            </a>
        );
    }

    slide = (e, dir) => {
        e.preventDefault();

        if (dir == 'next') {
            const first = this.el.querySelector('a:first-of-type');

            first.classList.add('move');

            setTimeout(() => {
                this.el.appendChild(first);
                first.classList.remove('move');
            }, 500);
        } else {
            const last = this.el.querySelector('a:last-of-type');

            last.classList.add('move');
            this.el.prepend(last);

            setTimeout(() => {
                last.classList.remove('move');
            }, 100);
        }
    }
}

const mapStateToProps = (state) => ({
    psychics: state.keen,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requirePsychics: () => dispatch({
        type: 'keen:init',
        payload: {
            tid: 'V3LTBSLU',
            size: 4,
        },
    }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);